export function replaceNode(node: HTMLElement, rule: string, html: string) {
  /*                                 */
  const range = document.createRange();
  range.selectNodeContents(node);

  /*                                                               */
  const fragment = range.createContextualFragment(html);

  /*           */
  range.deleteContents();
  range.insertNode(fragment);

  /*                     */
  node.dataset.rule = rule;
}
